import { useParamsSearch } from '@anytag/shared-hooks';
import { MarketplaceJoinedInfluencersSearchSchemaTypes } from '../schemaTypes';

export const useMarketplaceJoinedInfluencersFilter = () =>
  useParamsSearch<MarketplaceJoinedInfluencersSearchSchemaTypes>();
